import React, { useState, useEffect, Fragment } from "react";
import { axiosInstance } from "../../axios/axiosInstance";

export const ManufacturerBlogContent = ({ id }) => {
  const [blogContent, setBlogContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogContent = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.post("HtmlFeatureBlog/GetBrandBlogContent", { id: String(id) });
        setBlogContent(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    // Keep the previous blog visible until the new one loads (avoids a blank-then-fill flash on
    // brand change); only clear immediately when there's no valid brand to fetch.
    if (id && id > 0) fetchBlogContent();
    else setBlogContent(null);
  }, [id]);

  return (
    <Fragment>
      {blogContent && (
        <div className="row">
          <div className="brand-content my-3">
            <div dangerouslySetInnerHTML={{ __html: blogContent }} />
          </div>
        </div>
      )}
    </Fragment>
  );
};
